import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { defaultOption } from './data.js';
export class MarginSidePlugin {
    constructor(opt) {
        this.name = 'marginSide';
        this.renderToolbarItem = {
            marginSide: () => {
                const select = document.createElement('exeditor-toolbar-select');
                select.label = this.editor.t('两端缩进');
                const iconWrapper = document.createElement('span');
                iconWrapper.appendChild(createIcon({
                    name: 'marginSide',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.marginSideIcon),
                }));
                select.appendChild(iconWrapper);
                this.opt.options.forEach((entry) => {
                    const option = document.createElement('exeditor-toolbar-option');
                    option.slot = 'option';
                    option.value = entry.value;
                    option.textContent = this.editor.t(entry.label);
                    option.onclick = () => {
                        this.editor.focus();
                        this.set([entry.value, entry.value]);
                    };
                    select.appendChild(option);
                });
                const setBtnProps = () => {
                    const [marginLeft, marginRight] = this.get();
                    select.active = Boolean(marginLeft && marginRight);
                    select.value = marginRight || this.opt.default;
                    select.disabled = !this.canApply();
                };
                setBtnProps();
                this.editor.on('idlechange', setBtnProps);
                return select;
            },
            marginLeftSide: () => {
                const select = document.createElement('exeditor-toolbar-select');
                select.label = this.editor.t('段落缩进');
                select.shortcut = 'Mod-m';
                const iconWrapper = document.createElement('span');
                iconWrapper.appendChild(createIcon({
                    name: 'marginLeftSide',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.marginLeftSideIcon),
                }));
                select.appendChild(iconWrapper);
                this.opt.options.forEach((entry) => {
                    const option = document.createElement('exeditor-toolbar-option');
                    option.slot = 'option';
                    option.value = entry.value;
                    option.textContent = this.editor.t(entry.label);
                    option.onclick = () => {
                        this.editor.focus();
                        this.set([entry.value, '']);
                    };
                    select.appendChild(option);
                });
                const setBtnProps = () => {
                    const [marginLeft, marginRight] = this.get();
                    select.active = Boolean(marginLeft && !marginRight);
                    select.value = marginLeft || this.opt.default;
                    select.disabled = !this.canApply();
                };
                setBtnProps();
                this.editor.on('idlechange', setBtnProps);
                return select;
            },
        };
        this.findNextValue = (value, incOrDec) => {
            var _a;
            const foundIndex = (_a = this.opt.options) === null || _a === void 0 ? void 0 : _a.findIndex((entry) => entry.value === value);
            if (foundIndex === -1) {
                return '';
            }
            const index = incOrDec === 'increase' ? foundIndex + 1 : foundIndex - 1;
            const nextOption = this.opt.options[index];
            if (!nextOption) {
                return null;
            }
            return nextOption.value;
        };
        this.increaseMargin = () => {
            const margin = this.findNextValue(this.get()[0], 'increase');
            if (margin !== null)
                this.set([margin, '']);
        };
        this.decreaseMargin = () => {
            const margin = this.findNextValue(this.get()[0], 'decrease');
            if (margin !== null)
                this.set([margin, '']);
        };
        this.canApply = () => this.editor.selection().hasNode(this.opt.target);
        this.opt = {
            ...defaultOption,
            ...opt,
        };
        this.specExtraAttrs = {
            marginLeft: {
                target: this.opt.target,
                parse: (elt) => elt.style.marginLeft,
                toDOMAttribute: (marginLeft) => ({
                    style: marginLeft ? `margin-left: ${marginLeft}` : '',
                }),
            },
            marginRight: {
                target: this.opt.target,
                parse: (elt) => elt.style.marginRight,
                toDOMAttribute: (marginRight) => ({
                    style: marginRight ? `margin-right: ${marginRight}` : '',
                }),
            },
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                get: this.get,
            },
            shortcuts: {
                'Mod-m': this.increaseMargin,
                'Mod-Shift-m': this.decreaseMargin,
            },
        };
    }
    set([marginLeft, marginRight]) {
        this.editor.selection(true).updateNodeAttr(this.opt.target, [
            { name: 'marginLeft', value: marginLeft },
            { name: 'marginRight', value: marginRight },
        ]);
    }
    get() {
        const selection = this.editor.selection();
        const marginLeft = selection.getNodeAttr(this.opt.target, 'marginLeft');
        const marginRight = selection.getNodeAttr(this.opt.target, 'marginRight');
        return [marginLeft, marginRight];
    }
}
//# sourceMappingURL=index.js.map